import styled from "styled-components";

import { Checkbox, FormControlLabel } from "@libraries/mui";

const Container = styled.div`
  width: 100px;
`;

const CustomFormControlLabel = styled(FormControlLabel)`
  .MuiCheckbox-root {
    padding: 0 0 0 9px;
  }

  .MuiTypography-root {
    font-size: 13px;
    line-height: 0.8rem;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  color: ${({ theme }) => theme.colors.primary} !important;
`;

export { Container, CustomFormControlLabel, CustomCheckbox };
